class RegistrationForm {
  constructor() {
    this.modal = document.getElementById('registration-modal');
    this.overlay = document.getElementById('registration-modal-overlay');
    this.triggerSelector = '[href="#Register"],[data-registration-trigger]';
    this.closeSelector = '[data-registration-close]';

    if (!this.modal || !this.overlay) return;

    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      // Open
      const trigger = e.target.closest(this.triggerSelector);
      if (trigger) {
        e.preventDefault();
        this.open();
      }

      // Close
      const closeBtn = e.target.closest(this.closeSelector);
      if (closeBtn || e.target === this.overlay) {
        this.close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  open() {
    this.modal.style.display = 'flex';
    this.overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.modal.style.display = 'none';
    this.overlay.style.display = 'none';
    document.body.style.overflow = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new RegistrationForm();
});
